// Real photography from Coach Elete (authentic, brand-defining).
const real = {
  huddle:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/9sk0uayl_IMG_6171.JPG", // clipboard huddle (COACH ELETE)
  mentor:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/4bewtuha_IMG_3538%202.JPG", // 1-on-1 with a player
  bench:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/oeglzixi_IMG_9115.JPG", // directing from the bench
  courtside:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/lskzmmxx_IMG_3534.JPG", // courtside, arms folded (moody)
  team:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/izd41n0u_IMG_9748.JPG", // Hawks team photo
  stretch:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/nclac2af_DSC01499.jpeg", // assisting a player's stretch
  teamAlt:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/u958j6fz_E9BD7498-FCA6-48D5-8790-7FE48A9FD00D.JPG", // Hawks team photo (alt angle)
  empowerMentor:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/gj856eso_Empoer%20Image%201.png", // coaching a player 1-on-1 (Empower)
  empowerCloseup:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/sj3lg761_Empower%20image%202.png", // focused close-up portrait (Empower)
  davidXia:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/kptbkfax_David%20Xia%20Photo.png", // David Xia driving to the basket
  almasAdil:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/ocks43ng_IMG_0539.webp", // Almas Adil, Hawks #4
  aliRahbari:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/bqadtp8c_Ali%20.png", // Ali Rahbari, Hawks #9 (jump shot)
  jackGordon:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/ajogjrae_jack%203.webp", // Jack Gordon, Hawks #23
  markPhoto:
    "https://customer-assets.emergentagent.com/job_silly-joliot-5/artifacts/o6k39amo_mark%20photo%20.webp", // Mark's favourite shot — bench celebration
  teamHuddle:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/qtr8hudy_Teaching%20image%201.webp", // team huddle at center court (teaching moment)
  homeCallingGroup:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/fqh5fr66_IMG_9522.webp", // UHill full group / senior night (KALEB KIM banner)
  girlsChampions:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/tr6ipfwy_5469.webp", // girls team — Primetime tournament champions
  coachTeaching:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/fglajt87_IMG_3538%202.webp", // Coach Elete coaching a player one-on-one on court
  coachStretchFloor:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/zvciotiv_pick%20up%20clevon%20image.png", // Coach Elete assisting a player's stretch on the floor
  falconsCoaches:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/l9xfy3j0_IMG_3690.webp", // Falcons team celebrating on court
  falcons1:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/6978zxdu_IMG_3691.webp",
  falcons2:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/lpsta616_IMG_3692.webp",
  falcons3:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/0yrp8xmv_IMG_3693.webp",
  falcons4:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/5hn4xm8e_IMG_3694.webp",
  falcons5:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/v2g8tecb_IMG_3695.webp",
  ericHoop:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/iqysnhg8_eric%20replacement%20photo.webp", // ball through the net, 30s shot clock (Eric Xu story)
};

export const images = {
  // Hero & signature
  heroCoach: real.courtside,
  coachHuddle: real.huddle,
  // Relationships / story
  coachMentor: real.mentor,
  coachPortrait: real.empowerCloseup,
  // Teaching / leadership
  coachChalkboard: real.bench,
  coachBench: real.bench,
  // Atmospheric
  coachSideline: real.empowerMentor,
  hoopersTraining:
    "https://customer-assets-jai6qajn.emergentagent.net/job_silly-joliot-5/artifacts/6h4qq2ab_shane%20hd%20training%20pic.png",
  arenaDark: real.huddle,
  coachCourtside: real.courtside,
  // Culture / program
  teamPhoto: real.team,
  teamAlt: real.teamAlt,
  practicePlayers: real.teamAlt,
  // Player development / hands-on
  coachStretch: real.stretch,
  // Athlete story portraits
  davidXia: real.davidXia,
  almasAdil: real.almasAdil,
  aliRahbari: real.aliRahbari,
  jackGordon: real.jackGordon,
  markPhoto: real.markPhoto,
  teamHuddle: real.teamHuddle,
  homeCallingGroup: real.homeCallingGroup,
  girlsChampions: real.girlsChampions,
  coachTeaching: real.coachTeaching,
  coachStretchFloor: real.coachStretchFloor,
  falconsCoaches: real.falconsCoaches,
  falconsGallery: [real.falcons1, real.falcons2, real.falcons3, real.falcons4, real.falcons5],
  ericHoop: real.ericHoop,
  // Texture (kept for variety in thumbnails / backgrounds)
  dunkDark:
    "https://images.unsplash.com/photo-1608245449230-4ac19066d2d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxiYXNrZXRiYWxsJTIwcGxheWVyJTIwcHJhY3RpY2V8ZW58MHx8fHwxNzgyNjE5ODMyfDA&ixlib=rb-4.1.0&q=85",
  ballFloor:
    "https://images.unsplash.com/photo-1540712260984-d701320a8909?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxiYXNrZXRiYWxsJTIwdHJhaW5pbmclMjBkcmlsbCUyMGd5bXxlbnwwfHx8fDE3ODI2MTk5MDF8MA&ixlib=rb-4.1.0&q=85",
  heroCourt:
    "https://images.unsplash.com/photo-1577416412292-747c6607f055?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxkYXJrJTIwZW1wdHklMjBiYXNrZXRiYWxsJTIwY291cnR8ZW58MHx8fHwxNzgyNjE5ODMzfDA&ixlib=rb-4.1.0&q=85",
};
